"use client";
import { jsxs as a, jsx as n } from "react/jsx-runtime";
import { forwardRef as B } from "react";
import { BannerAction as d } from "./banner-action.js";
import { BannerBody as f } from "./banner-body.js";
import { BannerClose as p } from "./banner-close.js";
import { BannerIcon as u } from "./banner-icon.js";
import { BannerRoot as h } from "./banner-root.js";
const o = B(
  (e, i) => {
    const { actionButton: r, tone: m, children: l, closeButton: t, isOpen: c, ...s } = e;
    return /* @__PURE__ */ a(o.Root, { ref: i, isOpen: c, tone: m, ...s, children: [
      /* @__PURE__ */ n(o.Body, { children: l }),
      r ? /* @__PURE__ */ n(o.Action, { children: r }) : null,
      t ? /* @__PURE__ */ n(o.Close, { asChild: !0, children: t }) : null
    ] });
  }
);
o.Root = h;
o.Action = d;
o.Body = f;
o.Close = p;
o.Icon = u;
o.displayName = "Banner";
export {
  o as Banner
};
//# sourceMappingURL=banner.js.map
